import { makeStyles } from '@fluentui/react-components';
import React, { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultTooltipHostV9 } from './DefaultTooltipHostV9';

export interface IFunctionalAccessDisableWrapperProps {
    hasFunctionalAccess: boolean | undefined;
}

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
});
const FunctionalAccessDisableWrapper: React.FC<PropsWithChildren<IFunctionalAccessDisableWrapperProps>> = ({
    hasFunctionalAccess,
    children,
}) => {
    const { t } = useTranslation();
    const styles = useStyles();
    if (!hasFunctionalAccess) {
        return (
            <DefaultTooltipHostV9
                content={t('noFunctionalAccess')}
                alwaysDisplay
                relationship='description'
                appearance='inverted'
                withArrow
                positioning='after'
                containerClassName={styles.root}
            >
                {React.cloneElement(children as any, {
                    disabled: !hasFunctionalAccess,
                    disabledFocusable: !hasFunctionalAccess,
                })}
            </DefaultTooltipHostV9>
        );
    }

    return <>{children}</>;
};

export default FunctionalAccessDisableWrapper;
